__turbopack_context__.v({
  "border-tab": "authorisationDetails-module-scss-module__ltkuTG__border-tab",
  "border-title": "authorisationDetails-module-scss-module__ltkuTG__border-title",
  "brief": "authorisationDetails-module-scss-module__ltkuTG__brief",
  "container": "authorisationDetails-module-scss-module__ltkuTG__container",
  "detail": "authorisationDetails-module-scss-module__ltkuTG__detail",
  "detail-header": "authorisationDetails-module-scss-module__ltkuTG__detail-header",
  "detail-list": "authorisationDetails-module-scss-module__ltkuTG__detail-list",
  "detail-list-item": "authorisationDetails-module-scss-module__ltkuTG__detail-list-item",
  "detail-special": "authorisationDetails-module-scss-module__ltkuTG__detail-special",
  "detail-vertical": "authorisationDetails-module-scss-module__ltkuTG__detail-vertical",
  "fade-in-u0abkyo": "authorisationDetails-module-scss-module__ltkuTG__fade-in-u0abkyo",
  "sublist-container": "authorisationDetails-module-scss-module__ltkuTG__sublist-container",
  "tabs": "authorisationDetails-module-scss-module__ltkuTG__tabs",
  "title": "authorisationDetails-module-scss-module__ltkuTG__title",
  "title-icon": "authorisationDetails-module-scss-module__ltkuTG__title-icon",
});
